import React, { useEffect, useState, useLayoutEffect } from 'react'
import IconsPath from '../../../assets/icons';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import { Tooltip } from 'antd';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { Image as NoImg } from 'lucide-react';

function SalesCard(props) {

    const { outerIndex = null, handleMouseMove = () => { }, focusedIndex = null, mainImgKey = "", item = {}, imageOnClick = () => {} } = props;

    const [currentImgUrl, setCurrentImgUrl] = useState(props?.item?.[props.mainImgKey] || "");

    const isImagePreviewAvailable = (imageUrl) => {
        return new Promise((resolve) => {
            if (!imageUrl) return resolve(false);
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => resolve(imageUrl); // Resolve with URL if image loads
            img.onerror = () => resolve(false);   // Resolve with false if it fails
        });
    };

    useEffect(() => {
        const checkImage = async () => {
            const available = await isImagePreviewAvailable(item?.[mainImgKey] || "");
            setCurrentImgUrl(available);
        };
        checkImage();
    }, [item?.[mainImgKey]])

    const small = (str) => {
        if (str != null) {
            var str = str.toString()
            if (str.length <= 27) {
                return false;
            }
            return true;
        }
    }
    return (
        <div ref={props.lastListElementRef} key={outerIndex} className={`cursor-pointer splrscs-card splrscs-card-${props?.viewProductType} ${focusedIndex === outerIndex ? "hover" : ""} ${props?.isOutOfStock ? "splrscs-card-out-of-stock" : ""}`} onMouseLeave={(e) => handleMouseMove(e, null)} onMouseEnter={(e) => handleMouseMove(e, Number(outerIndex))} onClick={e=> props?.handleSelect?.(props?.item, e)}>
            <div className='splrscsc-inner'>
                <div className="splrscsc-top">
                    {/* For multiselect icon */}
                    {props?.multipleSelect && <label className="generic-checkbox" onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        props?.handleSelect?.(props?.item, e);
                    }}>
                        <input type="checkBox" checked={props?.selectedData[props?.item?.id] ? true : false} style={{zIndex:99}} onChange={() => {}} />
                        <span className="checkmark1"></span>
                    </label>}

                    {/* For wishlist icon */}
                    {/* {props.wishlist && (
                        <button className={`heart-icon ${props.wishlist?.isWishlisted?.() && "heart-icon-active"}`} onClick={() => props.wishlist.onClick()}>
                            <IconsPath.GreyHeart />
                        </button>
                    )} */}

                    {props?.isAddedToBag && (
                        <div className="splrscsc-added-to-bag-tag">
                            <span><LanguageTranslator>Added to Bag</LanguageTranslator></span>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2.2" />
                                <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    )}

                    {props?.isOutOfStock && (
                        <div className="splrscsc-out-of-stock-tag">
                            <span><LanguageTranslator>Out of Stock</LanguageTranslator></span>
                        </div>
                    )}

                    {currentImgUrl ? <div className='splrscsct-img' onClick={(e) => e.stopPropagation()}><img onClick={(e) => { e.stopPropagation(); imageOnClick("openMediaViewModal", item, e); }} src={currentImgUrl} style={{objectFit: props?.viewFullScreen ? "contain" : "cover"}} /></div> :
                        <div className='splrscsc-no-img-found' onClick={(e) => e.stopPropagation()}>
                            <NoImg />
                        </div>}
                </div>
                {!props.showCardButtonsDownDirection && <div className='splrscsc-btns'>
                    {(props?.viewProductType == "grid") && props?.buttons?.map((item, index) => {
                        return <>
                            <GenericCustomButton
                                {...item}
                            />
                        </>
                    })}
                    {props?.comment && props?.comment()}
                </div>}
                <div className={`splrscsc-details relative ${props?.isDetCustomClass ?? '!pb-0'}`}>
                    {props?.topExtra && <div className='absolute top-[12px] right-[0px] z-[3]'>{typeof props?.topExtra == "function" ? props?.topExtra({
                            item : props.item
                        }) : props?.topExtra }</div>}
                    {props?.showColor && <span className='splrsmv-color splrsmv-top'>{props?.item?.[props?.showColor] || "NA"}</span>}
                    {props?.showDataKey && Object.keys(props?.showDataKey).map((key, index) =>
                        <div className="splrscscd-info">
                            <LanguageTranslator tag="span" className='splrscsci-head'>{props?.showDataKey?.[key]}</LanguageTranslator>
                            {small(props?.item?.[key]) ? <Tooltip overlayClassName="button-tooltip"
                                title={<p>{props?.item?.[key] ?? "NA"}</p>}
                                color='black'
                            >
                                <span className='splrscsci-para'>{props?.item?.[key] ?? "NA"}</span>
                            </Tooltip> : <span className='splrscsci-para'>{props?.item?.[key] ?? <LanguageTranslator>NA</LanguageTranslator>}</span>}
                            <div className='flex items-center'>
                                {props?.viewProductType == "list" && index == 0 && <>
                                    {props?.showColor && <span className='splrsmv-color splrsmv-bottom'>{props?.item?.[props?.showColor] ?? "NA"}</span>}
                                    {props?.tagsKey && Object.keys(props?.tagsKey).map((key) =>
                                        <div className="splrscscd-tags">
                                            {props?.tagsKey?.[key] && <LanguageTranslator tag="span" className='splrscsci-head'>{props?.tagsKey?.[key]}: </LanguageTranslator>}
                                            {/* <span className='splrscsci-para'>{props?.item?.[key] ?? "NA"}</span> */}
                                            {small(props?.item?.[key]) ? <Tooltip overlayClassName="button-tooltip"
                                                title={<p>{props?.item?.[key] ?? "NA"}</p>}
                                                color='black'
                                            >
                                                <span className='splrscsci-para whitespace-nowrap text-ellipsis overflow-hidden max-w-[170px] block'>{props?.item?.[key] ?? "NA"}</span>
                                            </Tooltip> : <span className='splrscsci-para whitespace-nowrap text-ellipsis overflow-hidden max-w-[170px] block'>{props?.item?.[key] ?? <LanguageTranslator>NA</LanguageTranslator>}</span>}
                                        </div>
                                    )}
                                </>
                                }
                            </div>
                        </div>
                    )}
                    {props?.viewProductType == "grid" && props?.tagsKey && Object.keys(props?.tagsKey).map((key) =>
                        <div className="splrscscd-tags">
                            {props?.tagsKey?.[key] && <LanguageTranslator tag="span" className='splrscsci-head'>{props?.tagsKey?.[key]}: </LanguageTranslator>}
                            {/* <span className='splrscsci-para'>{props?.item?.[key] || "NA"}</span> */}
                            {small(props?.item?.[key]) ? <Tooltip overlayClassName="button-tooltip"
                                title={<p>{props?.item?.[key] || "NA"}</p>}
                                color='black'
                            >
                                <span className='splrscsci-para whitespace-nowrap text-ellipsis overflow-hidden max-w-[170px] block'>{props?.item?.[key] || "NA"}</span>
                            </Tooltip> : <span className='splrscsci-para whitespace-nowrap text-ellipsis overflow-hidden max-w-[170px] block'>{props?.item?.[key] || <LanguageTranslator>NA</LanguageTranslator>}</span>}
                        </div>
                    )}
                </div>

                {props?.bottomExtras && (typeof (props?.bottomExtras) == "function" ? props?.bottomExtras(props?.item, outerIndex) : props?.bottomExtras)}
                               
                {(props?.viewProductType == "list" || props.showCardButtonsDownDirection) && <div className='splrscsc-btns !border-0 pb-2.5'>
                    {props?.buttons?.map((item, index) => {
                        return <>
                            <GenericCustomButton
                                {...item}
                            />
                        </>
                    })}
                     {props?.comment && props?.comment()}
                </div>}
            </div>
        </div>
    )
}

export default SalesCard